module.exports = __webpack_public_path__ + "1781d363627527a29a18812a7d092ccd.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/city-32.png
 ** module id = 1024
 ** module chunks = 0
 **/